import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import Routes from '@/router/routes';
import { cn } from '@/lib/utils';

export interface ITelletsTableProps {
  name: string;
  status: string;
  number_of_respondents: number;
  date_published: string;
  completion_rate: string;
  published_by: string;
}

export const OrganizationTelletsColumns = () => {
  const columns: ColumnDef<ITelletsTableProps>[] = [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Name
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <div className="flex items-center gap-3">
          <Link
            className="transition-all ease-in-out hover:text-primary hover:underline"
            to={`${Routes.super_admin_dashboard_single_organization.path}/id`}
          >
            {row?.getValue('name')}
          </Link>
        </div>
      ),
    },
    {
      accessorKey: 'status',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Status
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => (
        <p
          className={cn(
            'whitespace-nowrap',
            row.getValue('status') === 'Completed' &&
              'px-4 text-green-800 w-fit py-px bg-green-200 rounded-full',
            row.getValue('status') === 'In Progress' &&
              'px-5 text-orange-800 w-fit py-px bg-orange-200 rounded-full',
          )}
        >
          {row.getValue('status')}
        </p>
      ),
    },
    {
      accessorKey: 'number_of_respondents',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Nr. of respondents
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('number_of_respondents')}</>,
    },
    {
      accessorKey: 'date_published',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Date published
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('date_published')}</>,
    },
    {
      accessorKey: 'completion_rate',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Completion rate
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('completion_rate')}</>,
    },
    {
      accessorKey: 'published_by',
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="pl-0"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Published by
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      ),
      cell: ({ row }) => <>{row.getValue('published_by')}</>,
    },
  ];
  return columns;
};
